export default __webpack_public_path__ + "static/media/midsize.3c33d56c.png";